/*!jslint
  this
*/
jQuery(function($) {
    "use strict";


    function appHeight() {
        var wh = $(window).innerHeight();
        document.documentElement.style
            .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $(function() {
        AOS.init({
            easing: 'ease-in-out-sine',
            duration: 400,
            once: true
        });
    });

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.site-header').outerHeight();

    $(window).scroll(function(event) {
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(window).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st > lastScrollTop && st > 1) {
            $('.site-header').removeClass('nav-down').addClass('nav-up');
        } else {
            if (st + $(window).height() < $(document).height()) {
                $('.site-header').removeClass('nav-up').addClass('nav-down');
            }
        }
        if (st > navbarHeight) {
            $('.site-header').addClass('sticky');
        } else {
            $('.site-header').removeClass('sticky');
        }

        if (st == 0) {
            $('.site-header').removeClass('nav-up nav-down');
        }

        lastScrollTop = st;
    }


    $(document).on('click', '.nav-toggle', function(e) {
        $(this).toggleClass('on');
        $('html').toggleClass('nav-open');
    });
   /* $('.logo-carosuel-ltr').slick({
        dots: false,
        infinite: true,
        arrows: false,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 0,
        speed: 5000,
        draggable: false,
    });
    $('.logo-carosuel-rtl').slick({
        dots: false,
        infinite: true,
        arrows: false,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 0,
        speed: 5000,
        rtl: true,
        draggable: false,
    });*/

    $('.logo-carosuel-item').each(function () {
        const $container = $(this);
        const $images = $container.find('.lci-img');
        let index = 0;
        $container.find('.lci-img:first-child').addClass('active');

        setInterval(function () {
            $images.removeClass('active');
            $images.eq(index).addClass('active');
            index = (index + 1) % $images.length;
        }, 3000); // Adjust interval as needed
    });

    $('.image-cl-main').slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 500,
        easing: 'ease-in-out',
        nextArrow: '<span class="slick-arrow slick-next"><svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" d="M6.15088 23.5L18.7269 12.374C18.7797 12.3271 18.8221 12.2695 18.8511 12.205C18.88 12.1406 18.895 12.0707 18.895 12C18.895 11.9293 18.88 11.8594 18.8511 11.795C18.8221 11.7305 18.7797 11.6729 18.7269 11.626L6.15088 0.5"/></svg></span>',
        prevArrow: '<span class="slick-arrow slick-prev"><svg width="25" height="24" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin" fill="none"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" d="M18.8491 23.5L6.27312 12.374C6.22025 12.3271 6.17793 12.2695 6.14894 12.205C6.11996 12.1406 6.10497 12.0707 6.10497 12C6.10497 11.9293 6.11996 11.8594 6.14894 11.795C6.17793 11.7305 6.22025 11.6729 6.27312 11.626L18.8491 0.5"/></svg></span>',
    });


    $(document).on('click', '.pricing-table-item-head a', function(e) {
        e.preventDefault();
        var type = $(this).attr('data-type');
        var sp = $(this).attr('data-' + type + '-sp');
        var op = $(this).attr('data-' + type + '-op');
        var $price = $(this).parents('.pricing-table-item').find('.pricing');

        $('.pricing-table-item-head a').removeClass('active');
        $(this).addClass('active');

        $price.find('span:first-child').html(sp);
        $price.find('span:last-child').html(op);

        // Fixed duplicate keys
        $('.pt-annual').attr({
            "data-annual-sp": $(this).attr('data-annual-sp'),
            "data-annual-op": $(this).attr('data-annual-op')
        });

        $('.pt-lifetime').attr({
            "data-lifetime-sp": $(this).attr('data-lifetime-sp'),
            "data-lifetime-op": $(this).attr('data-lifetime-op')
        });
        $('#fremius-popup').attr({
            "data-value": $(this).attr('data-value'),
            "data-type": type
        });

    });

    $(document).on('click', '.pricing-toggle a', function(e) {
        e.preventDefault();
        var type = $(this).attr('data-type');

        $('.pricing-toggle a').removeClass('active');
        $(this).addClass('active');

        $('.pricing-table-item.pt-product').find('.pricing').each(function() {
            var $price = $(this);
            var sp = $price.attr('data-' + type + '-sp');
            var op = $price.attr('data-' + type + '-op');

            $price.find('span:first-child').html(sp);
            $price.find('span:last-child').html(op);
        });

        $('.pricing-table-item-head a').attr('data-type', type);
        $('.ptic-in').hide();
        $('.ptic-in.' + type).show();
        $('.pricing-label').html($(this).data('text'));
        $('.fremius-popup').attr('data-type', type);
    });

    $(document).on('click', '.add-on-price-switch a', function(e) {
        e.preventDefault();
        var type = $(this).attr('data-type');

        $('.add-on-price-switch a').removeClass('active');
        $(this).addClass('active');

        $('.add-on-price-item').each(function(index) {
            $(this).attr('data-type', type);
            var sp = $(this).attr('data-' + type + '-sp');
            var op = $(this).attr('data-' + type + '-op');
            $(this).find('.pricing strong:first-child').html(sp);
            $(this).find('.pricing strong:nth-child(2)').html(op);
        });
        $('#add-on-purchase').attr('data-type', type);
    });

    $(document).on('click', '.add-on-price-item', function(e) {
        e.preventDefault();
        var type = $(this).attr('data-type');
        var sp = $(this).attr('data-' + type + '-sp');
        var op = $(this).attr('data-' + type + '-op');
        var value = $(this).attr('data-value');
        $('.add-on-price-item').removeClass('active');
        $(this).addClass('active');
        $('#add-on-purchase').attr('data-value', value);

    });



    $('.faq-item-head').click(function() {
        $('.faq-item-head').removeClass('on');
        $('.faq-item-content').slideUp('normal');
        if ($(this).next().is(':hidden') == true) {
            $(this).addClass('on');
            $(this).next().slideDown('normal');
        }
    });

     $('.ft-grid-item').on('mouseover mouseout', function(e) {
      const evt = e.type;
      var video = $(this).find('video')[0];
      if (evt === 'mouseover') {
        //video.load();
        video.play();
      }
      if (evt === 'mouseout') {
        video.pause();
      }
    });

});